import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonZoom from '../../../components/Editor/ButtonZoom';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			combo: { isCombining },
		},
	} = state;

	return {
		isDisabled: isCombining,
	};
};

export default connect(mapStateToProps)(ButtonZoom);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonZoom/index.tsx